import React, { createContext, useState } from 'react';

interface DialogContextData {
  openDialog: boolean;
  setOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
  handleCloseDialog: () => void;
  handleOpenDialog: () => void;
}

interface DialogProviderProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any;
}

export const DialogContext = createContext<DialogContextData>({} as DialogContextData);

const DialogProvider: React.FC<DialogProviderProps> = ({ children }) => {
  const [openDialog, setOpenDialog] = useState<boolean>(false);

  const handleCloseDialog = () => setOpenDialog(false);

  const handleOpenDialog = () => setOpenDialog(true);

  return (
    <DialogContext.Provider
      value={{
        openDialog,
        setOpenDialog,
        handleCloseDialog,
        handleOpenDialog
      }}
    >
      {children}
    </DialogContext.Provider>
  );
};

export default DialogProvider;
